import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">{contactData.title}</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">{contactData.subtitle}</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center mb-8">{contactData.desc}</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            <a
              href={`mailto:${contactData.email}`}
              className="flex items-center gap-4 p-5 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-300/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-0.5">电子邮件</div>
                <div className="text-sm font-medium text-foreground-800 break-all">{contactData.email}</div>
              </div>
            </a>

            <div className="flex items-center gap-4 p-5 rounded-xl bg-background-100 border border-background-200/60">
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-accent-600 text-xl"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400 mb-0.5">微信咨询</div>
                <div className="text-sm font-medium text-foreground-800">{contactData.wechat}</div>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3">
            {contactData.tips.map((tip, i) => (
              <span key={i} className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
                {tip}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}